import { render, staticRenderFns } from "./SuspensaoPage.vue?vue&type=template&id=ae5b5b1e&scoped=true"
import script from "./SuspensaoPage.vue?vue&type=script&lang=js"
export * from "./SuspensaoPage.vue?vue&type=script&lang=js"
import style0 from "./SuspensaoPage.vue?vue&type=style&index=0&id=ae5b5b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5b5b1e",
  null
  
)

export default component.exports